/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFLocale } from './CRSFLocale';
import {
    CRSFLocaleFromJSON,
    CRSFLocaleFromJSONTyped,
    CRSFLocaleToJSON,
} from './CRSFLocale';

/**
 * Model contains only data to trigger underwriting (quick_scan) process with domains.
 * @export
 * @interface CRSFTriggerUWRequest
 */
export interface CRSFTriggerUWRequest {
    /**
     * 
     * @type {string}
     * @memberof CRSFTriggerUWRequest
     */
    account_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFTriggerUWRequest
     */
    active_desired_policy_uuid?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFTriggerUWRequest
     */
    domains: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFTriggerUWRequest
     */
    extended_aggr_timeout?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CRSFTriggerUWRequest
     */
    external_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFTriggerUWRequest
     */
    force?: boolean;
    /**
     * 
     * @type {CRSFLocale}
     * @memberof CRSFTriggerUWRequest
     */
    locale?: CRSFLocale;
    /**
     * 
     * @type {string}
     * @memberof CRSFTriggerUWRequest
     */
    quote_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFTriggerUWRequest
     */
    renewal_of_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFTriggerUWRequest
     */
    request_origin?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFTriggerUWRequest
     */
    retained_from_uuid?: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFTriggerUWRequest
     */
    signal_id?: number;
}

/**
 * Check if a given object implements the CRSFTriggerUWRequest interface.
 */
export function instanceOfCRSFTriggerUWRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "domains" in value;

    return isInstance;
}

export function CRSFTriggerUWRequestFromJSON(json: any): CRSFTriggerUWRequest {
    return CRSFTriggerUWRequestFromJSONTyped(json, false);
}

export function CRSFTriggerUWRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFTriggerUWRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account_id': !exists(json, 'account_id') ? undefined : json['account_id'],
        'active_desired_policy_uuid': !exists(json, 'active_desired_policy_uuid') ? undefined : json['active_desired_policy_uuid'],
        'domains': json['domains'],
        'extended_aggr_timeout': !exists(json, 'extended_aggr_timeout') ? undefined : json['extended_aggr_timeout'],
        'external_id': !exists(json, 'external_id') ? undefined : json['external_id'],
        'force': !exists(json, 'force') ? undefined : json['force'],
        'locale': !exists(json, 'locale') ? undefined : CRSFLocaleFromJSON(json['locale']),
        'quote_id': !exists(json, 'quote_id') ? undefined : json['quote_id'],
        'renewal_of_uuid': !exists(json, 'renewal_of_uuid') ? undefined : json['renewal_of_uuid'],
        'request_origin': !exists(json, 'request_origin') ? undefined : json['request_origin'],
        'retained_from_uuid': !exists(json, 'retained_from_uuid') ? undefined : json['retained_from_uuid'],
        'signal_id': !exists(json, 'signal_id') ? undefined : json['signal_id'],
    };
}

export function CRSFTriggerUWRequestToJSON(value?: CRSFTriggerUWRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account_id': value.account_id,
        'active_desired_policy_uuid': value.active_desired_policy_uuid,
        'domains': value.domains,
        'extended_aggr_timeout': value.extended_aggr_timeout,
        'external_id': value.external_id,
        'force': value.force,
        'locale': CRSFLocaleToJSON(value.locale),
        'quote_id': value.quote_id,
        'renewal_of_uuid': value.renewal_of_uuid,
        'request_origin': value.request_origin,
        'retained_from_uuid': value.retained_from_uuid,
        'signal_id': value.signal_id,
    };
}

